@use '@design/design-tokens/typography/typography' as *;

.root {
    display: flex;
    flex-direction: column;
    gap: 32px;
    padding: 16px 0 16px 24px;
}

.body {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}

.description {
    @include typography-v2-body-base;
    color: var(--text-default);
}

.gold {
    border-left: 2px solid var(--text-decorative-gold);
}

.indigo {
    border-left: 2px solid var(--kg-theme);
}

.teal {
    border-left: 2px solid var(--text-decorative-teal);
}

.purple {
    border-left: 2px solid var(--text-decorative-purple);
}